import type { BioContext } from '@ps/functions/bio/bioContext';
import { bioUrl } from '@ps/functions/bio/bioUrls';

/**
 * The checkout post-success return target for the bio subscribe surface: the
 * launcher's explicit `redirect_to` (the content a subscription-gated button
 * unlocks), else the creator's bio home.
 *
 * ALWAYS present so the continuation survives the paths that outlive the SPA —
 * a 3DS-redirect return and a checkout page refresh — where the opener is gone
 * and checkout can't `router.back()`. A relative path is sufficient (checkout
 * returns to the same origin).
 */
export function subscribeSuccessRedirect(
  bioContext: BioContext,
  successRedirectUrl?: string,
): string {
  return successRedirectUrl ?? bioUrl(bioContext).home();
}
